import { Component } from '@angular/core';
import { BaseModalComponent } from '../../../core/modals/components/base-modal/base-modal.component';

@Component({
  selector: 'app-joint-responsibility-agreement',
  templateUrl: './joint-responsibility-agreement.component.html',
  styleUrls: ['./joint-responsibility-agreement.component.scss'],
})
export class JointResponsibilityAgreementComponent extends BaseModalComponent<{}> {}
